import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class SystemSettings {
    accountActivationReminderEmailDelayInDays: string;
    accountCreatedEmail: boolean;
    analyticsTrackingId: string;
    autoAccountActivationEmail: boolean;
    autoAccountActivationReminderEmail: boolean;
    automatedUploadEmail: string;
    automatedUploadFolder: string;
    catalogueReferences: CatalogueReferences[]
    defaultPlatformLanguage: string; 
    enableAutomaticBanking: boolean;
    ianaTimeZone: string;   
    nackleCompanyId: string;
    nackleSecretKey: string;
    organisationUpdateMethod: string;
    platformAdminEmail: string;
    pointStatementEmail: boolean;
    platformLanguages: PlatformLanguages[]
    showPointBalanceInPlatform: boolean;
    transactionWiseBanking: boolean;
    userUpdateMethod: string;
    otpBasedLogin: boolean;
    otpBasedActivation: boolean;
    isFIFOEnabled: boolean;
    showExpiredData: boolean;
    preloginAccess: any;
}

export class CatalogueReferences {
    catalogueId: string;
    isEnableExperience: boolean;
    isEnableMerchandise: boolean;
    isoCode: string;
    programNumber: string;
}

export class PlatformLanguages {
    languageCulture: string;
    languageName: string;
}

export class PlatformSystemSettings {    
    catalogueReferences: CatalogueReferences[]
    defaultPlatformLanguage: string;    
    ianaTimeZone: string;    
    platformLanguages: PlatformLanguages[]
    showPointBalanceInPlatform: boolean;    
    otpBasedLogin: boolean;
    otpBasedActivation: boolean;
    isFIFOEnabled:boolean;
    showExpiredData:boolean;
    mostRedeemedDefaultId: string;
    preloginAccess: any;
}